import { ZION_BUILD } from '../buildInfo.ts'

const v = `?v=${ZION_BUILD}`

/** Icona ufficiale Web/PWA (uccello su bianco). */
export const APP_ICON_192 = `/app/icons/icon-192.png${v}`
export const APP_ICON_512 = `/app/icons/icon-512.png${v}`

export function splashLogoHtml(size = 96): string {
  return `<img class="app-logo" src="${APP_ICON_192}" width="${size}" height="${size}" alt="ZION" />`
}
